<template>
  <b-modal
    v-model="isVisible"
    hide-footer
    size="lg"
  >
    <h2 class="text-center">Procesos pendientes de la atencion medica</h2>

    <b-card class="mb-0 mt-2" style="border:1px solid #c9c9c9;">

      <div
        v-for="derivacion in derivaciones"
        :key="derivacion.id"
        class="d-flex align-items-center justify-content-between my-1 px-2"
      >
        <h6>Derivacion {{derivacion.especialidad}}</h6>
        <b-button
          variant="success"
          @click="onRedirectToDerivacion(derivacion.id)"
        >
          Completar
        </b-button>  
      </div>

      <hr v-if="derivaciones.length > 0 && interconsultas.length > 0">

      <div
        v-for="interconsulta in interconsultas"
        :key="interconsulta.id"
        class="d-flex align-items-center justify-content-between my-1 px-2"
      >
        <h6>Interconsulta {{interconsulta.especialidad.descripcion}}</h6>

        <b-button
          v-if="interconsulta.estadoInterconsulta === '99'"
          variant="success"
          @click="onRedirectToInterconsulta(interconsulta.token)"
        >
          Completar
        </b-button>
        
        <span
          v-if="interconsulta.estadoInterconsulta === '1'"
          class="text-success px-1"
        >
          <font-awesome-icon icon="circle-check" style="margin-right:5px ;"/>
          Completado
        </span>
      </div>
      
    </b-card>

    <div class="my-1 mb-1 d-flex align-items-center justify-content-end">
      <b-button class="d-flex" @click="onCompletarDespues">
        Completar despues
      </b-button>  
    </div>
    
  </b-modal>
</template>

<script>
import { interconsultaService } from '../../services';

export default {

  name: "ModalItemsByAtencion",

  props:{

  },

  data() {
    return{
      isVisible:false,

      atencionId:null,

      derivaciones:[],
      interconsultas:[],

    }
  },


  created() {
    this.setAtencionId();
  },

  methods: {

    async loadDataModal(atencionId){

      const dataInterconsultas = await interconsultaService.getByAtencionId(atencionId);
      // console.log('dataInterconsultas', dataInterconsultas);

      if(!dataInterconsultas){
        this.$swal("Error", "La atención no existe.", "error")
          .then(
            () => this.$router.push({ name: 'interconsultas' })
          );
        return;
      }

      this.isVisible = true;
      this.interconsultas = dataInterconsultas;
    },

    onCompletarDespues(){
      console.log('onCompletarDespues');
      this.isVisible = false;
    },

    setAtencionId(){
      this.atencionId = this.$route.query.pending;
      this.derivaciones = [];
      this.interconsultas = [];
    },

    onRedirectToDerivacion(derivacionId){
      this.$router.push({ name: "derivaciones", query: { completar:derivacionId } });
    },

    onRedirectToInterconsulta(interconsultaToken){
      this.$router.replace({ name: "interconsultas", query:{ completar:interconsultaToken } });
    },
  },


  watch: {
    'route.query.pending':{
      handler(){
        // console.log('llegue a pending')
        this.setAtencionId();
      }
    },


    atencionId: {
      deep: true,
      handler(newValue) {
        if(!newValue) return;
        this.loadDataModal(newValue);
      }
    },

    isVisible: {
      deep: true,
      handler(newValue) {
        if( !newValue ) this.$router.push({ name: 'interconsultas' })
      }
    },


  }


}
</script>